import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { EventTypes } from '../../../shared/EventTypes';
import { BaseResult } from '../../../shared/models/base.result.model';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { Util } from '../../../utils/util';
import { PixPaymentFavoredView } from '../models/payment-favored-view.model';
import { PixPaymentFavored } from '../models/payment-favored.model';
import { ETipoOperacao, PixQrCodeReturn } from '../models/qr-code-return.model';
import { TipoIniciacaoTransferencia } from '../models/tipo-iniciacao-transacao.enum';
import { PixPaymentKeyService } from '../payment-key/payment-key.service';
import { WithdrawChangeService } from '../withdraw-change/service/withdraw-change.service';
import { PixQrCodeDynamicService } from './qr-code-dynamic/qr-code-dynamic.service';
@Component({
	selector: 'app-pix-copy-and-paste',
	templateUrl: './copy-and-paste.component.html',
	styleUrls: ['./copy-and-paste.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixCopyAndPasteComponent implements OnInit {

	public form: FormGroup;
	public url: string;
	public withdrawChangeUrl = '/pix/pagamento/saque-e-troco/pix-copia-cola';

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		public dialog: MatDialog,
		private pixPaymentKeyService: PixPaymentKeyService,
		private pixQrCodeDynamicService: PixQrCodeDynamicService,
		private withdrawChangeService: WithdrawChangeService
	) {}

	ngOnInit(): void {
		this.pixPaymentKeyService.clearState();
		this.pixQrCodeDynamicService.clearState();
		this.withdrawChangeService.setDescription('')

		this.buildForm();
		this.url = this.router.url;
	}

	buildForm() {
		this.form = this.formBuilder.group({
			value: ['', Validators.required],
		});
	}

	submit() {
		if (this.form.valid) {
			this.getQrCode();
		}
	}

	getQrCode() {
		const code = this.form.get('value').value;
		this.pixPaymentKeyService.getInfoByCode(code).subscribe(result => {
			if (result.Sucesso && result.Existe) {
				if (result.Retorno.Tipo === 'DINAMICO') {
					this.setDynamicPixResponse(result);
					this.redirectPixDynamicTo();
				} else {
					this.setStaticPixResponse(result);
					this.redirectPixStaticTo();
				}
			}
		}, error => this.handleError(error));
	}

	goBack = () => {
		if(this.url === this.withdrawChangeUrl) {
			this.router.navigate(['pix/pagamento/saque-e-troco']);
			return;
		}

		this.router.navigate(['pix']);
	}

	private redirectPixStaticTo() {
		const pixPaymentFavoredView = this.pixPaymentKeyService.getSelectedPixPaymentFavoredView();
		if (pixPaymentFavoredView.tipoOperacao === ETipoOperacao.PAGAMENTO) {
			if(this.valueIsGreaterThanZero(pixPaymentFavoredView.valorQrCode)){
			this.setStaticPixWithValue(pixPaymentFavoredView);
			this.router.navigate(["pix/pagamento/favorecido/adicionar/resumo"]);
			return;
		}
			this.router.navigate(['pix/pagamento/favorecido/adicionar/valor-data']);
			return;
		}

		this.router.navigate(['pix/pagamento/saque-e-troco/pix-copia-cola/valor-data']);
	}

	private redirectPixDynamicTo() {
		const qrCodeDynamic = this.pixQrCodeDynamicService.getSelectedPixQrCodeReturn().qrCodeDinamico;

		if (qrCodeDynamic.tipoOperacao === ETipoOperacao.PAGAMENTO) {
			this.router.navigate(['pix/pagamento/qrcode-dinamico']);
			return;
		}

		if (qrCodeDynamic.saque || qrCodeDynamic.troco) {
			this.router.navigate(['pix/pagamento/saque-e-troco/pix-copia-cola/valor-data']);
			return;
		}
	}

	private setDynamicPixResponse(result: BaseResult<any>) {
		const model = Util.keysToCamel(result.Retorno) as PixQrCodeReturn;
		model.tipoIniciacaoTransacao = TipoIniciacaoTransferencia.QRCODE;
		this.pixQrCodeDynamicService.setSelectedPixQrCodeReturn(model);
	}

	private setStaticPixResponse(result: BaseResult<any>) {
		const model = Util.keysToCamel(result.Retorno) as PixPaymentFavored;
		const pixPaymentFavoredView = new PixPaymentFavoredView(model);
		pixPaymentFavoredView.tipoIniciacaoTransacao = TipoIniciacaoTransferencia.QRCODE;
		this.pixPaymentKeyService.setSelectedPixPaymentFavoredView(pixPaymentFavoredView);
	}

  private setStaticPixWithValue(pixPaymentFavoredView: PixPaymentFavoredView) {
    pixPaymentFavoredView.valorTransferir = pixPaymentFavoredView.valorQrCode;
    pixPaymentFavoredView.descricaoTransferir = pixPaymentFavoredView.descricao;
    pixPaymentFavoredView.dataTransferir = new Date();
    sessionStorage.rota = "copy-paste";
    this.pixPaymentKeyService.setSelectedPixPaymentFavoredView(pixPaymentFavoredView);
  }

	private valueIsGreaterThanZero(value: number) {
    return value > 0;
  }

	handleError = (error) => AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/copy-and-paste/copy-and-paste.component.ts